import { getCell, getName } from "utils/insightsAndAlarmsUtils";
import { getYesOrNo } from "utils/utils";
import { INSIGHT_HISTORY_TABLE_STRINGS, INSIGHT_TABLE_STRINGS } from "constants/constantStrings";

import InsightsListCheckboxRenderer from "pages/SmartInsight/InsightsList/InsightsListCheckboxRenderer";

import InsightHeaderCheckboxRenderer from "./InsightHeaderCheckboxRenderer";

const getHeaderWithCheckboxCol = field => ({
  field,
  editable: false,
  sortable: false,
  headerComponentParams: { field },
  valueFormatter: params => getYesOrNo(params.data[field]),
  headerComponentFramework: InsightHeaderCheckboxRenderer,
  cellRendererFramework: InsightsListCheckboxRenderer,
  cellRendererParams: { field }
});

export const INSIGHT_LIST_TABEL_COL_DEF = [
  {
    field: "Insight Name",
    headerName: INSIGHT_HISTORY_TABLE_STRINGS.insightName,
    flex: 2,
    editable: false,
    valueFormatter: getName,
    defaultSort: "desc"
  },
  {
    field: "AnomalyType",
    headerName: INSIGHT_HISTORY_TABLE_STRINGS.tagName,
    flex: 1.5,
    editable: false
  },
  {
    field: "Insight Description",
    headerName: INSIGHT_HISTORY_TABLE_STRINGS.insightDescription,
    flex: 2.5,
    editable: false,
    valueFormatter: params => getCell(params, "description")
  },
  {
    field: "Alert",
    headerName: INSIGHT_TABLE_STRINGS.headerAlert,
    flex: 1,
    minWidth: 140,
    ...getHeaderWithCheckboxCol("Alert")
  },
  {
    field: "ShowInReport",
    headerName: INSIGHT_TABLE_STRINGS.headerAddToReport,
    flex: 1,
    minWidth: 155,
    ...getHeaderWithCheckboxCol("ShowInReport")
  }
];

export const getInsightListConfig = (filter, headerProps, admin) =>
  INSIGHT_LIST_TABEL_COL_DEF.map((colDef, idx) => {
    if (idx > 2) {
      const { headerComponentParams } = colDef;
      headerComponentParams.headerProps = headerProps;
      colDef = { ...colDef, headerComponentParams };
    } else {
      colDef = { ...colDef, filter };
    }

    return colDef;
  });
